/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function () {
				// JavaScript to be fired on all pages

				$("#menu-primary-navigation").find(".dropdown-toggle").attr("data-toggle", "");
				$("#menu-user-navigation").children("li:not(.menu-search)").find(".dropdown-toggle").attr("data-toggle", "");
				$("#mobile-menu-primary-navigation").find(".dropdown-toggle").attr("data-toggle", "");
				$("#menu-event-site-navigation").find(".dropdown-toggle").attr("data-toggle", "");

				$("#main-site-nav-toggle .navbar-toggle").on("click", function(){
					$("#main-site-slide-in-nav").addClass("open");
				});

				$("#main-site-slide-in-nav .close-btn").on("click", function(){
					$("#main-site-slide-in-nav").removeClass("open");
				});

				$("#search-dropdown-close").on("click", function(){
					$(".menu-search.open .dropdown-toggle").dropdown("toggle");

				});

				if($("#testimonial-carousel .item.active").has(".top-level-content-holder") &&
					$("#testimonial-carousel .item.active .top-level-content-holder").html() !== "")
				{

					$("#testimonial-carousel .top-level-wrap").html($("#testimonial-carousel .item.active .top-level-content-holder").html());

				}

				$("#testimonial-carousel")
					.on("slid.bs.carousel", function(evt){

						$(".top-level-wrap", this).html($(evt.relatedTarget).find(".top-level-content-holder").html());

						$(".top-level-wrap > div:first-child", this).css("opacity", 0).fadeTo("fast", 1);

					})
					.on("slide.bs.carousel", function(evt){

						$(this).find(".top-level-wrap > div:first-child").fadeTo("fast", 0);

					});

				// Content list infinite feed
				if($("button.view-more-btn").length > 0){

					if($("#list-content-loader").length < 1){
						$("button.view-more-btn").hide();
					}

					$("button.view-more-btn").on("click", function(){

						var spinnerIcon = $(this).find("span.fa-spinner");
						var contentLoader = $("#list-content-loader");

						var viewMoreBtn = $(this);

						spinnerIcon.css("display", "inline-block");

						var action = "get_posts";

						if((contentLoader.data("action") !== undefined) && (contentLoader.data("action") !== "")) {
							action = contentLoader.data("action");
						}

						$.post(
							ajaxVars.ajaxurl,
							{
								"action": action,
								"data": $.param(contentLoader.data())
							},
							function(data){

								contentLoader.remove();

								if(data){

									spinnerIcon.hide();

									$("#content-list").append(data);

									// Look for the new content loader tag
									// If it's not there, there aren't any more posts to show so hide the view more button
									if($("#list-content-loader").length < 1){
										viewMoreBtn.parent().remove();
									}

								}else{

									viewMoreBtn.parent().remove();

									$("#content-list").append('<p>No more posts available</p>');

								}

							}
						);

					});

				}

				$("#footer-testimonial").load(ajaxVars.ajaxurl + "?action=get_random_testimonial");

				// Enhanced animations for collapsible elements

				$(".panel-collapse")
					.on("show.bs.collapse", function(){
						$(this).animate({
							marginTop: "toggle"
						});
						$(this).parent().addClass("panel-open");
					})
					.on("hide.bs.collapse", function(){
						$(this).animate({
							marginTop: "toggle"
						});
						$(this).parent().removeClass("panel-open");
					});

				$(".panel-collapse.in").parent().addClass("panel-open");

				$('input[type="radio"][data-toggle="tab"]').on("shown.bs.tab", function(evt){
					$(evt.currentTarget).prop("checked", true);
				});

				$(".js-add-to-cart-btn").on("click", function(){

					var addToCartBtn = $(this);

					var origBtnText = addToCartBtn.text();

					addToCartBtn
						.prop("disabled", true)
						.html($("<span>").addClass("fa fa-pulse fa-spinner"));

					var data = {
						"post_id": 		$(this).data("post-id"),
						"post_type": 	$(this).data("post-type")
					};

					if(typeof $(this).data("extra-params") !== undefined && $(this).data("extra-params") !== ""){
						data.extra_params = $(this).data("extra-params");
					}

					$.post(
						ajaxVars.store_ajaxurl,
						{
							"action": "add_to_cart",
							"data": $.param(data)
						},
						function(data) {

							if(data.status){

								addToCartBtn.text(addToCartBtn.data("completed-text"));

								addToCartBtn.removeClass("btn-primary").addClass("btn-default-inverse");

								if(addToCartBtn.data("success-msg") !== undefined){
									triggerAddToCartModal(addToCartBtn, addToCartBtn.data("success-msg"), "success");
								}

								addToCartBtn.trigger("rm.cart.updated");

							}else{

								var errorMsg = "There was an error adding the item to the cart.  Please try again.";

								if(typeof data.message === "string" && data.message !== ""){
									errorMsg = data.message;
								}

								triggerAddToCartModal(addToCartBtn, errorMsg, "error");

								addToCartBtn.prop("disabled", false).text(origBtnText);

							}

						}

					);

				});

				if($("#signup-fields, #billing-info, #account-company-details-fields").length > 0) {

					$("#signup-fields, #billing-info, #account-company-details-fields")
						.addressfield(addressFieldConfig)
						.on("addressfield:after", function (e, data) {

							$(".locality-wrap:hidden", this).find(".form-group :input").prop("disabled", true);

							// Ensure that any hidden fields in the top locality-wrap div are also set to disabled
							$(".locality-wrap", this).first().children(".form-group:hidden").find(":input:hidden").prop("disabled", true);

							// Ensure that any fields in the top locality-wrap div that might
							// have been previously hidden and disabled are now enabled
							$(".locality-wrap", this).first().children(".form-group:not(:hidden)").find(":input:disabled").prop("disabled", false);

							// Update required attribute for any field based on json file

							// Create a field config object that we can actually use
							var fieldsConfig = {};

							for(var i in data.config.fields){

								// Get first key and store that key's value
								for(var j in data.config.fields[i]){
									fieldsConfig[j] = data.config.fields[i][j];
									break;
								}

							}

							// Loop through all fields and see if any config data exists for the field
							for(var fieldKey in data.fieldMap){

								// If there is config data and the "required" setting exists
								if((typeof fieldsConfig[fieldKey] !== "undefined") && (typeof fieldsConfig[fieldKey].required !== "undefined")){

									// Set field's required property to value defined in addressfield json
									$(data.fieldMap[fieldKey], this).attr("required", fieldsConfig[fieldKey].required);

								}else{

									// Otherwise default field's required property to true
									$(data.fieldMap[fieldKey], this).attr("required", true);

								}

							}

							$(".locality-wrap label").each(function () {

								if ($(this).text().slice(-1) !== "*") {
									$(this).append("*");
								}

							});

						});

				}

				if($("#signup-fields").length > 0){

					$("#signup-fields").append(
						$("<input>")
							.prop({
								"type": "hidden",
								"name": "form_data[signup-fields][honey_pot]"
							})
					);

				}

				if($("#date-filter-datepicker-trigger").length > 0) {

					$("#date-filter-datepicker-trigger").daterangepicker(
						{
							startDate: $("#date-filter-datepicker-trigger").data("start-date"),
							endDate: $("#date-filter-datepicker-trigger").data("end-date"),
							showDropdowns: true,
							linkedCalendars: false,
							opens: "center",
							locale: {
								format: $("#date-filter-datepicker-trigger").data("date-format")
							},
							applyClass: "btn-primary",
							cancelClass: "btn-default"
						},
						function (start, end) {

							var trigger = $("#date-filter-datepicker-trigger");

							var dateFormat = trigger.data("date-format");

							$(trigger.data("start-date-target")).val(start.format(dateFormat));
							$(trigger.data("end-date-target")).val(end.format(dateFormat));

						}
					).on("click", function (evt) {
						return false;
					});

				}

				$("#event-listing-filter-submit").on("click", function(){

					var redirectUrl = ((ajaxVars.root_url !== undefined) ? ajaxVars.root_url : "") + "/conferences/";

					if($('#event-listing-filter form :input[name="sector"]').val() !== ""){

						redirectUrl += $('#event-listing-filter form :input[name="sector"]').val() + "/";

					}

					var queryString = $('#event-listing-filter form :input[name!="sector"]').filter(function(){
						return (this.value !== "");
					}).serialize();

					if(queryString !== ""){
						redirectUrl += "?" + queryString;
					}

					window.location.href = redirectUrl;

					return false;

				});

				$("#js-event-filter-toggle").on("click", function(){
					$("#event-filter-bar").toggle();
					$("#js-clear-filter-btn").parent().toggle();
					$(this).text(function(i, existingVal){
						return (existingVal === "Hide filter") ? "Show filter" : "Hide filter";
					});
					return false;
				});

				$("#js-clear-filter-btn").on("click", function(){

					$("#event-listing-filter form :input").val("");

					var redirectUrl = ((ajaxVars.root_url !== undefined) ? ajaxVars.root_url : "") + "/conferences/";

					if(redirectUrl !== window.location.href){
						window.location.href = redirectUrl;
					}

					return false;

				});

				// Update cart icon with proper number on page load, to get around page caching
				updateCartItemCount();

				$("body").on("rm.cart.updated", function(){
					updateCartItemCount();
				});

				$(".locality-wrap").on("blur", ".input-postal-code .form-control", function(){

					var postalCodePattern = /^[A-Z][0-9][A-Z]\ *[0-9][A-Z][0-9]$/;

					var postalCodeVal = $(this).val().toUpperCase().trim();

					if(postalCodePattern.test(postalCodeVal)){

						// If the value contains a space
						if(postalCodeVal.indexOf(" ") >= 0){

							// Replace any instance of one or more spaces with a space
							postalCodeVal = postalCodeVal.replace(/\ +/g, " ");

						}else{

							postalCodeVal = postalCodeVal.substr(0, 3) + " " + postalCodeVal.substr(3);

						}

						$(this).val(postalCodeVal);

					}

				});
                                
                                //bootstrap dropdown on mobile
//                                $(".dropdown").click(function(e){
//                                    if( $(this).children(".dropdown-menu").hasClass("show-dropdown")){
//                                        $(this).children(".dropdown-menu").removeClass("show-dropdown" );
//                                    }
//                                    else{
//                                        $(this).children(".dropdown-menu").addClass("show-dropdown" );
//                                    }
//                                    
//                                   // e.preventDefault();
//                                });

			},
			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page
			},
			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		'blog':{
			init: function(){
				var clickCount = 0;
				//blog categories toggle for blog listing page
				$('.category-toggle').click(function(){
					clickCount++;
					if ( clickCount % 2 === 1 ){
						$('#blog-topics-list').show();
						$('.category-toggle').html('Hide Topics');
					}
					else{
						$('#blog-topics-list').hide();
						$('.category-toggle').html('Show Topics');
					}
				});
			}
		},
		//cart checkout page
		'checkout' : {
			init: function(){

				/*
				Duplicate Company Details for attendees
				 */
				// Only need to enable to checkbox if there's more than 1 set of attendee fields
				if($(".attendee-company").length > 1){

					$('.attendee-company').first().append(
						'<div class="row">' +
							'<div class="full-width checkbox form-group-column">' +
								'<label for="duplicate-company-details">' +
									'<input id="duplicate-company-details" type="checkbox" class="duplicate-company-details">Duplicate company details for all attendees' +
								'</label>' +
							'</div>' +
						'</div>'
					);

					$('.duplicate-company-details').click(function(){

						//get entered fields
						var company = $(this).closest('.attendee-company');
						var companyInputs = $(this).closest('.attendee-company').find(':input');
						var companyItems = [];

						$(companyInputs).each(function(i, el){
							var companyVal = $(el).val();
							var companySelect = $(el).closest('div').attr('class');
							var valObj = {
								selector: companySelect,
								userVal: companyVal
							};
							companyItems.push( valObj );
						});

						$(companyItems).each(function(i, el){
							var itemClass = '.' + el.selector.replace(/ /g,".");
							var itemVal = el.userVal;
							$(itemClass).find('input, select').val( itemVal );
						});
					});

				}
			}
		},
		// Account page
		'um_page_account': {
			init: function () {
				// JavaScript to be fired on the account page

				if($(".um-account-link.current").data("tab") !== "general"){

					$(".um-account-main .um-account-tab-general")
						.find(".form-group :input").prop("disabled", true);

				}

				$(".um-account-link").on("click", function(){

					if($(this).data("tab") === "general"){

						$(".um-account-main .um-account-tab-" + $(this).data("tab"))
							.find(".form-group :input").prop("disabled", false);

					}else if($(".um-account-link.current").data("tab") === "general"){

						$(".um-account-main .um-account-tab-" + $(".um-account-link.current").data("tab"))
							.find(".form-group :input").prop("disabled", true);

					}

				});

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

	var triggerAddToCartModal = function(target, modalMsg, type){

		if(typeof type === undefined){
			type = "";
		}

		if($("#js-add-to-cart-modal").length > 0){

			$("#js-add-to-cart-modal").find(".modal-body").html(modalMsg);

			if(type === "error"){

				$("#js-add-to-cart-modal").find(".modal-footer .btn-view-cart").hide();
				$("#js-add-to-cart-modal").find(".modal-footer .btn-continue").hide();
				$("#js-add-to-cart-modal").find(".modal-footer .btn-close").show();

			}else{

				$("#js-add-to-cart-modal").find(".modal-footer .btn-view-cart").show();
				$("#js-add-to-cart-modal").find(".modal-footer .btn-continue").show();
				$("#js-add-to-cart-modal").find(".modal-footer .btn-close").hide();

			}

			$("#js-add-to-cart-modal").modal({show: true});

		}

	};

	var updateCartItemCount = function(){

		$.get(
			ajaxVars.ajaxurl,
			{
				"action": "get_cart_item_count"
			},
			function(data){
				if(data !== ""){
					$("#js-cart-count-indicator").text(data);
				}
			}
		);

	};

})(jQuery); // Fully reference jQuery after this point.
